import React, {useState}  from 'react'
import '../parseller/./gallery.css'
import '../Insaat/SultangaziProjeler.css';

import CloseIcon from '@mui/icons-material/Close';
import { Container,Box,Paper,Grid,Typography } from '@mui/material';
import rsm1014 from '../imageproje/Insaat/BelgratEv/Belgrat_Salon.avif';
import img1 from '../imageproje/Insaat/BelgratEv/02.avif';
import img2 from '../imageproje/Insaat/BelgratEv/03.avif';
import img3 from '../imageproje/Insaat/BelgratEv/04.avif';
import img4 from '../imageproje/Insaat/BelgratEv/05.avif';
import img5 from '../imageproje/Insaat/BelgratEv/06.avif';
import img6 from '../imageproje/Insaat/BelgratEv/07.avif';
import img7 from '../imageproje/Insaat/BelgratEv/08.avif';
import img8 from '../imageproje/Insaat/BelgratEv/09.avif';
import img9 from '../imageproje/Insaat/BelgratEv/10.avif';
import img10 from '../imageproje/Insaat/BelgratEv/Belgrat_Mutfak.avif';
import img11 from '../imageproje/Insaat/BelgratEv/Belgrat_Banyo.avif';
import Comunication from '../components/Comunication';
import ComunicationPhone from '../components/ComunicationPhone';
import ComunicationEmail from '../components/ComunicationEmail';

function BelgratMahallesiBir() {
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempimgSrc] = useState('');
    const getImg = (imgSrc) => {
        setTempimgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
      <Comunication/>
        <ComunicationPhone/>
        <ComunicationEmail/>
        <img src={rsm1014} alt="Cebeci Mahallesi" style={{width:'100%',marginTop:'83px',marginBottom:'20px'}} loading='lazy'/>
        <Container sx={{marginBottom:2}}>
            <Grid className='insaat-Link'>
                <a href="">HAKKINDA</a>
                <a href="" className='containerLinks'>PROJE ÖZELLİKLERİ</a>
                <a href="" >GALERİ</a>
            </Grid>
        </Container>
        <Container className='headDetail-Insaat'>
            <Typography variant='h5' component='p'>
                Metin Belgrad 1; Emlakçın Belgrad 1 Projesi
            </Typography>
            <Typography variant='body1' component='p'>
                <br />
                Modern mimarisi ve şehir yeşille kaplı özel konumuyla Metin Belgrad, herkes için yepyeni bir yaşamın kapılarını açıyor.
            </Typography>
        </Container>
        <Container fixed sx={{marginTop:3, marginBottom:3}}>
            <Grid className='insaatGenel' sx={{backgroundColor:'rgb(59, 73, 144)',width:'100%',height:'540px'}} gap={2}>
                <Grid size={12} sx={{padding:'40px 40px 0px 40px'}}>
                    <Typography className='writingColor' variant='h5' component='h5'>
                        PROJE ÖZELLİKLERİ
                    </Typography>
                    <Typography className='writingColor'  variant='body1' component='p'>
                        <br />
                        Şehrin yeşille kaplı en temiz bölgesinde huzurlu ve konforlu bir yaşam sürmeye hazır mısınız? Emlakçın'ın hazırladığı Metin Belgrad 
                        Çatalca size ayrıcalıklı bir yaşamın kapılarını aralıyor. İstanbul Avrupa Yakası'ndaki eşsiz doğası ve İstanbul Hava Alanına kısa 
                        sürede ulaşmanın ayrıcalığını sunuyor.
                    </Typography>
                </Grid>
                <Grid  className='insatDetailInfo' sx={{display:'flex',padding:4}} gap={2}>
                    <Grid  size={6} sx={{width:'50%',height:340, backgroundColor:'white'}}>
                        <img className='insatDetailImg' src={img10} alt="" style={{width:'100%',height:'100%'}}/>
                    </Grid>
                    <Grid size={6} className='writingColor' sx={{width:'50%',height:340,padding:3}}>
                        Her Detayı Düşünülen Özel Bir Proje 
                        <br/>
                        <br/>
                        Geniş bir alana sahip proje modern mimarisi ve şehrin ana arterlerine yakın konumuyla huzur bir yaşam alanı vadediyor. 
                        Sunduğu ayrıcalıklarla Belgrad konut projeleri arasında öne çıkan Metin Belgrad;
                        2+1 seçenekleriyle her beklentiye uygun alternatifler sunuyor. 
                        Farklı metrekarelere sahip konutlar gün ışığı alan cepheleriyle aydınlık ve ferah bir konaklama imkânı sunuyor. 
                        <br/>
                        <br/>
                         Modern detaylarla konforlu bir yaşam alanı sunan Metin Belgrad projesiyle huzurlu ve lüks bir yaşamı deneyimleyebilirsiniz.
                    </Grid>
                </Grid>
            </Grid>
        </Container>
        <Container fixed sx={{marginTop:3, marginBottom:3}}>
            <Grid className='insatDetailInfoTop' sx={{backgroundColor:'rgb(59, 73, 144)',width:'100%',height:'370px'}} gap={2}>
                <Grid className='insatDetailInfo' sx={{display:'flex',padding:4}} gap={2}>
                    <Grid size={6}  sx={{width:'50%',height:300, backgroundColor:'white', padding:0}}>
                        <img className='insatDetailImg' src={img11} alt="" style={{width:'100%',height:'100%',objectFit:'fill'}}/>
                    </Grid>
                    <Grid size={6} className='writingColor' sx={{width:'50%',height:300,padding:3}}>
                        Lokasyon
                        <br/>
                        <br/>
                        “Çatalca-Beylikdüzü” aksıyla beraber değerlendirilen; doğal plajları, ormanlarda yürüyüş yolları, tarihi kültürel yapıları ve 
                        her gün genişleyen ulaşım ağı ile yatırım değerini her geçen gün artırıyor. Çatalca bölgesi, ulaşım hatlarının kesiştiği bir noktada yer 
                        alması ve kolay ulaşılabilirliği ile konut, ofis ve otel yatırımlarının tercih edildiği bölgeler arasında bulunuyor.
                    </Grid>
                </Grid>
            </Grid>
        </Container>
        <Container>
            <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1L5wKLHuj-4QYTNbltHne9EflfgNU-Kg&ehbc=2E312F&noprof=1" width="100%" height="480"></iframe>
        </Container>
        <Container>
            <Typography variant='h5' component='h5' style={{textAlign:'center',marginBottom:'20px'}}>
                PROJE AİT GÖRSELLER
            </Typography>
        </Container>
        <Container>
            <div className={model ? "model open" : "model"} >
                <img src={tempimgSrc} alt='Çatalca'loading='lazy'/>
                <CloseIcon onClick={() => setModel(false)}/>
            </div>
        </Container>
        <Container>
            <div className='gallery galaryList'>
                {DataItem1063.map((item, index) =>{
                    return(
                        <div className='pics' key={index} onClick={() => getImg(item.imgSrc)}>
                            <img src={item.imgSrc} alt='Çatalca' style={{width:'100%'}} loading='lazy'/>
                        </div>
                    )
                })}
            </div>
        </Container>
        <Container fixed sx={{marginTop:3, marginBottom:3}}>
            <Grid className='questionInfo' sx={{backgroundColor:'rgb(59, 73, 144)',width:'100%',height:'670px'}} gap={2}>
                <Grid size={12} sx={{padding:4}}>
                    <Typography className='writingColor'variant='h5' component='h5'>
                        SIKÇA SORULAN SORULAR
                    </Typography>
                    <Typography className='writingColor'variant='h6' component='h6' sx={{marginTop:2}}>
                        Her Yere Kolayca Ulaşın
                    </Typography>

                    <Typography className='writingColor'  variant='body1' component='p'>
                        <br />
                        İncelikli zevklere hitap eden ve yepyeni bir yaşam alanı sunan Metin Belgrad; 
                        Çatalca-Beylikdüzü aksında yer alıyor. Avrupa Yakası'nın en yeşil bölgesi 
                        proje "İstanbul Hava Alanına" kolay ve hızlı ulaşım sağlayan hatlara yakın bir konumda bulunuyor. 
                        Konut, villa yatırımlarının tercih edildiği bir bölgede olduğundan sadece konaklamak için değil; 
                        yatırım amacıyla da tercih edilebilecek ideal bir seçenek olarak öne çıkıyor. Gelişimini sürekli sürdüren 
                        bir bölgede bulunan proje çevrede yeşilliklerle dolu peyzajlı bahçeleriyle doğa ile iç içe bir yaşam deneyimi sunuyor.
                    </Typography>

                    <Typography className='writingColor'variant='h6' component='h6' sx={{marginTop:2}}>
                        Şehir Merkezinde Konforlu Bir Yaşam
                    </Typography>

                    <Typography className='writingColor'  variant='body1' component='p'>
                        <br />
                        Şehrin en yeşil bölgesinde huzurlu ve konforlu bir yaşam sürmeye hazır mısınız? 
                        Emlakçın tarafından hazırlanan Metin Belgrad size ayrıcalıklı bir yaşamın kapılarını aralıyor. 
                        İstanbul Avrupa Yakası'ndaki eşsiz konumuyla her yere kısa sürede ulaşmanın ayrıcalığını sunuyor. 
                        Modern ve zarif mimarisiyle İstanbul'a değer katan Metin Belgrad doğanın huzuru ile şehrin imkânlarını bir araya getiriyor. 
                        Siz de şehrin en yeşl ve temiz bölümünde huzurlu bir yaşam için size en uygun konutu tercih edebilir, 
                        incelikli düşünülmüş bir yaşama "Merhaba!" diyebilirsiniz.
                    </Typography>

                    <Typography className='writingColor'variant='h6' component='h6' sx={{marginTop:2}}>
                        Ayrıcalık ve Konforlu Yepyeni Bir Yaşam Sizi Bekliyor
                    </Typography>

                    <Typography className='writingColor'  variant='body1' component='p'>
                        <br />
                        Metin Belgrad ulaşım hatlarının kesiştiği noktadaki özel konumu ve sunduğu imkânlarıyla şehrin gözde yaşam 
                        merkezlerinden biri olmaya aday. Zevkli iç dekorasyonu, şık ve modern mimarisi, konfor sunan lüks yaşam 
                        alanlarıyla İstanbul'da hem sakin bir hayat sürmenize hem şehrin nabzını yakalamanıza olanak tanıyor. 
                        Keyifli bir yaşam alanı arayışında olanlar için ideal konut seçenekleri sunuyor. 
                        Siz de her detayı titiz bir çalışmanın ürünü olan Metin Belgrad'nın ayrıcalıklarla dolu dünyasına 
                        adım atmak isterseniz vakit kaybetmeden bizimle iletişime geçebilirsiniz. İstediğiniz cephede, 
                        ihtiyacınıza uygun metrekareye sahip seçkin konutlar arasından seçim yapmak için hemen randevu alabilir, 
                        aklınıza takılan soruları müşteri temsilcilerimize iletebilirsiniz.
                    </Typography>
                </Grid>
                
            </Grid>
        </Container>
        
    </>
  )
}

export default BelgratMahallesiBir;

const DataItem1063 = [
    { id:1, imgSrc:img1},
    { id:2, imgSrc:img2},
    { id:3, imgSrc:img3},
    { id:4, imgSrc:img4},
    { id:5, imgSrc:img5},
    { id:6, imgSrc:img6},
    { id:7, imgSrc:img7},
    { id:8, imgSrc:img8},
    { id:9, imgSrc:img9},
]


